module.exports = __webpack_public_path__ + "media/images/civ_WinTak_256-ebb92830061c26d545977f704b316dc5.png";